// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_24q9Nutk4U9PcxSnN407Y_"};